import React from 'react';
import styled from 'styled-components/macro';

import colors from 'styles/themes/colors';

export const CheckboxContainer = styled('svg')<any>`
  display: block;
  fill: transparent;
  width: ${({ newLayout }: any): string => (newLayout ? '1.6' : '1.25')}em;
  height: ${({ newLayout }: any): string => (newLayout ? '1.6' : '1.25')}em;
  margin-right: 0.5em;
  /** Fix a bug on iOS where the bottom line of the SVG doesn't show */
  transform: translate3d(0, 0, 0);
`;

const CheckboxBackground = styled('rect')<any>`
  fill: ${({ isChecked, dataColor }: any): string =>
    isChecked ? dataColor : 'white'};
  stroke: ${({ isChecked, insideDropdown }: any): string =>
    insideDropdown
      ? isChecked
        ? colors.AccentGreen
        : '#ACACAC'
      : isChecked
      ? 'transparent'
      : 'currentColor'};
  stroke-width: 1;
  opacity: ${({ disabled }: any): number => (disabled ? 0.8 : 1)};
`;

interface ICheckboxProps {
  enabledText: string;
  /** The title text of the SVG when  not checked */
  disabledText?: string;
  /** Wether the Checkbox is checked */
  isChecked?: boolean;
  /** The background color of the checkbox */
  color?: string;
  checkColor?: string;
  newLayout?: boolean;
  onClick?: any;
  disabled?: boolean;
  insideDropdown?: boolean;
  isMinus?: boolean;
}

const Checkbox: React.FC<ICheckboxProps> = ({
  enabledText,
  disabledText,
  isChecked,
  color = colors.AccentGreen,
  checkColor,
  newLayout,
  onClick,
  disabled,
  insideDropdown,
  isMinus,
}) => (
  <CheckboxContainer
    viewBox={`0 0 ${insideDropdown ? '20 20' : '26 26'}`}
    newLayout={newLayout}
    onClick={disabled ? undefined : onClick}
  >
    <title>{isChecked ? enabledText : disabledText}</title>
    <CheckboxBackground
      width={insideDropdown ? '16' : '24'}
      height={insideDropdown ? '16' : '24'}
      x="1"
      y="1"
      rx={insideDropdown ? '3' : '0'}
      ry={insideDropdown ? '3' : '0'}
      dataColor={color}
      isChecked={isChecked}
      disabled={disabled}
      insideDropdown={insideDropdown}
    />
    {isChecked && (
      <polygon
        fill={checkColor || 'white'}
        fillRule="nonzero"
        style={{
          transform: `translate(${insideDropdown ? '-3px, -3px' : '0,0'})`,
        }}
        width={insideDropdown ? '16' : '24'}
        points="17.666 7.293 19.08 8.707 10.373 17.414 6.293 13.334 7.707 11.92 10.373 14.586"
      />
    )}
    {isMinus && (
      <rect
        style={{
          transform: `translate(5px, 8px)`,
        }}
        width="8"
        height="2"
        fill={colors.AccentGreen}
      />
    )}
  </CheckboxContainer>
);

export default Checkbox;
